import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
const extras = [{
  name: 'Engine Bay Top',
  price: '$120'
}, {
  name: 'Headlight Restore',
  price: '$80'
}, {
  name: 'Clay Bar Treatment',
  price: '$60'
}, {
  name: 'Water Spots / Dog Hair',
  price: 'Call for Pricing'
}, {
  name: 'Ceramic Coating Glass',
  price: '$200'
}, {
  name: "CERAMIC COATING — 1 YEAR",
  price: 'Call for Pricing'
}];
export function Extras() {
  return <section className="w-full bg-black py-16 px-4" id="extras" data-id="element-146" data-mp="tr812os20pbu">
      <div className="max-w-7xl mx-auto" data-id="element-147" data-mp="ypjaiyefsxtj">
        <div className="relative bg-zinc-900/80 border-2 border-red-600/70 rounded-lg p-8 md:p-10 lg:p-12 overflow-hidden shadow-[0_0_30px_-5px_rgba(220,38,38,0.2)]" data-id="element-148" data-mp="ko6vqqb0j298">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-72 h-72 bg-red-600/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-149" data-mp="2f1olmjyw4b7f" />

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 mb-8 md:mb-10" data-id="element-150" data-mp="2j30dyx95fajb">
            <div className="text-center md:text-left" data-id="element-151" data-mp="107mh7wcsvnlc">
              <h2 className="text-4xl md:text-5xl font-black uppercase text-white mb-3" data-id="element-152" data-mp="v9uoj04bzxg3">
                <span className="text-red-600" data-id="element-153" data-mp="19yqwkx6e1agp">Extra</span> Services
              </h2>
              <p className="text-gray-400 text-lg md:text-xl" data-id="element-154" data-mp="1505xx26sayud">
                Add these to any package for the ultimate finish
              </p>
            </div>
            <div className="p-4 bg-red-600/10 border border-red-900/50 rounded-lg" data-id="element-155" data-mp="hcy35e6zf86l">
              <Plus className="w-9 h-9 text-red-500" data-id="element-156" data-mp="cduuzkvpglue" />
            </div>
          </div>

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-157" data-mp="ravp1v1dcsw1">
            {extras.map((extra, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center justify-between gap-4 p-5 md:p-6 bg-black/40 border border-zinc-700 rounded-lg hover:border-red-600/60 transition-colors" data-id="element-158" data-mp="mcaplxtxyd8n" data-mpi={index}>
                <span className="font-bold text-gray-200 uppercase tracking-wide text-xl" data-id="element-159" data-mp="2eq7jq8opwsjv">
                  {extra.name}
                </span>
                <span className="font-black text-red-500 text-2xl whitespace-nowrap" data-id="element-160" data-mp="2jpbtb0fk0saq">
                  {extra.price}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}